import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { getPayrollList, doPayrollDelete } from "../../../../redux/payroll/payrollState";
import { handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import PayrollForm from "./PayrollForm";
import PopupButton from "components/button/PopupButton";

const PayrollTable = ({recordList, pagination, doSearch, filters, doDelete, ...props}) => {
  	const {getColumnSearchProps} = ColumnSearchFilter();
  	const columns = [
	    {
	        title: `Date`,
	        dataIndex: 'pay_date_from',
	        key: 'pay_date_from',
	        width: '20%', 	        
	        ...getColumnSearchProps('pay_date_from'),
	        sorter: true, 
	        render:(pay_date_from, record) => <span>{`${pay_date_from} - ${record.pay_date_to}`}</span> 
	    },
	    {
	        title: `Type`,
	        dataIndex: 'pay_type_name',
	        key: 'pay_type_name',
	        width: '15%',
	        ...getColumnSearchProps('pay_type_name'), 
	        sorter: true,
	    },
	    {
	        title: `Status`,
	        dataIndex: 'pay_status_name',
	        key: 'pay_status_name',
	        width: '15%',
	        ...getColumnSearchProps('pay_status_name'), 
	        sorter: true,
	    },
	    {
	        title: `Notes`,
	        dataIndex: 'pay_notes',
	        key: 'pay_notes',
	        width: '38%',
	        
	    },
	    {
	        title: <PopupButton id="add_payroll" title="Add Payroll" label="Add" btnClass="btn-small">
						<PayrollForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'pay_id',
	        key: 'pay_id',
	        width: '12%',
	        render:(pay_id, record) => <CrudOption baseRoute="/console/payrolls" recordId={pay_id} allowDelete={record.pay_status_id !== 10} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="py-2">
				<SearchFilter 
					searchHandler={doSearch} 
					filters={filters} 
					pagination={pagination}
				/>
			</div>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.pay_id}
					scroll={{ x: "max-content" }}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}             	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.payroll.payrollList?.items,
	pagination: state.payroll.payrollList?.pagination,
	filters: state.payroll.payrollList?.filters,
  	requesting: state.payroll.payrollList?.requesting,
  	error: state.payroll.payrollList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getPayrollList(filters)),
  doDelete: (id) => dispatch(doPayrollDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollTable);
